import gql from "graphql-tag"

const SEARCH_ORDER_OPERATIONS_TOTAL_HITS = gql`
  query searchOrderOperations($from: Int!, $size: Int!, $sort: [SearchSorting!], $query: AWSJSON, $trackTotalHits: Boolean, $aggs: AWSJSON) {
    searchOrderOperations(
      from: $from,
      size: $size,
      sort: $sort,
      query: $query,
      trackTotalHits: $trackTotalHits,
      aggs: $aggs
    ) {
      total
      hits {
        id
      }
      aggregations
    }
  }
`

export default SEARCH_ORDER_OPERATIONS_TOTAL_HITS
